import React from 'react'
import { formattedDate } from '../../utils/formattedDate';

const ReportTab = ({ reportList }) => {
    const convertToDecimalHour = (isoTime) => {
        const date = new Date(isoTime);
        const hours = date?.getHours();
        const minutes = date?.getMinutes();
        const decimalMinutes = (minutes / 60).toFixed(2);
        const result = (hours + parseFloat(decimalMinutes)).toFixed(2);

        return result?.replace('.', ':');
    };
    return (
        <div className='founder-reports'>
            <div className='founder-report-section'>
                <div className="report-list">
                    {
                        reportList?.length > 0 &&
                        <>
                            {
                                reportList?.map((item, index) => {
                                    return <div className='report-list-card' key={index}>
                                        <div className='card-description'>
                                            <div className="list-name">Report #{item?.id}</div>
                                        </div>
                                        <div className='card-time'>
                                            <div className='card-time'>
                                                {`${formattedDate(item?.dateOfReported)} ${convertToDecimalHour(item?.dateOfReported)}` || "0:00"}
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default ReportTab